import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Box from '../../shared/atoms/Box';
import Text from '../../shared/atoms/Text';
import Heading from '../../shared/atoms/Heading';
import ToolkitFix from '../../shared/ToolkitFix';
// Icons
import LoveColor56 from '../../icons/LoveColor56';
import Chrono56 from '../../icons/Chrono56';
import Price56 from '../../icons/Price56';
import Party56 from '../../icons/Party56';

const ASmartGift = () => {
  const { t } = useTranslation();
  return (
    <Box
      flexDirection={{ xs: 'column', xl: 'row' }}
      mb={{ xs: 7, md: 110, lg: 130 }}>
      <Box flex={5} mr={{ xs: 0, lg: 8 }}>
        <Heading level={2} textAlign={{ xs: 'center', xl: 'start' }}>
          <Trans
            i18nKey="smartgift.headings.1"
            components={{
              gradiant: <span style={{ color: '#595FE7' }} />,
            }}
          />
        </Heading>
        <Text
          fontSize="xl"
          color="black"
          lineHeight="copy"
          fontWeight={1}
          textAlign={{ xs: 'center', xl: 'start' }}>
          {t('smartgift.text')}
        </Text>
        <Box mt={5} maxWidth={450} alignSelf={{ xs: 'center', xl: 'start' }}>
          <Box flexDirection="row" alignItems="center" mb={5}>
            <Box
              width={72}
              height={72}
              borderRadius="sm"
              bg="gray.lightest"
              alignItems="center"
              justifyContent="center"
              p={2}
              mr={4}>
              <Party56 alt="Bonus +10% carte cadeau" />
            </Box>
            <Heading level={5}>+10% offerts sur chaque carte</Heading>
          </Box>
          <Box flexDirection="row" alignItems="center" mb={5}>
            <Box
              width={72}
              height={72}
              borderRadius="sm"
              bg="gray.lightest"
              alignItems="center"
              justifyContent="center"
              p={2}
              mr={4}>
              <Chrono56 alt="Réparation rapide en 48h" />
            </Box>
            <Heading level={5}>{t('smartgift.headings.2')}</Heading>
          </Box>
          <Box flexDirection="row" alignItems="center" mb={5}>
            <Box
              width={72}
              height={72}
              borderRadius="sm"
              bg="gray.lightest"
              alignItems="center"
              justifyContent="center"
              p={2}
              mr={4}>
              <Price56 alt="Prix abordable réparation vélo" />
            </Box>
            <Heading level={5}>{t('smartgift.headings.3')}</Heading>
          </Box>
          <Box flexDirection="row" alignItems="center">
            <Box
              width={72}
              height={72}
              borderRadius="sm"
              bg="gray.lightest"
              alignItems="center"
              justifyContent="center"
              p={2}
              mr={4}>
              <LoveColor56 alt="Cadeau apprécié par les cyclistes" />
            </Box>
            <Heading level={5}>{t('smartgift.headings.4')}</Heading>
          </Box>
        </Box>
      </Box>
      <Box
        flex={4}
        position="relative"
        alignItems="center"
        mt={{ xs: 7, xl: 0 }}>
        <img
          src="/static/img/photos/giftcard/RepairAtHome.jpg"
          alt="Réparateur vélo intervenant à domicile"
          style={{ objectFit: 'contain', borderRadius: '24px' }}
        />
      </Box>
    </Box>
  );
};

export default ASmartGift;
